import 'semantic-ui-css/semantic.css'
import {Container} from 'semantic-ui-react'
import React from 'react';
import ReactDOM from 'react-dom';
import Main from './Main';

ReactDOM.render(
    <Container>
      <Main />
    </Container>,
  document.getElementById('root')
);
